import { GlobeX } from 'lucide-static';
import { api } from '../api.js'
import { Loader } from '../components.js'

// async function tryPing() {
//   try {
//     const response = await api.get('/ping')
//     return response
//   } catch (error) {    
//     console.log(`Healthcheck failed: can't reach the API. ${error}`)
//     return false
//   } 
// }

async function tryHealth() {
  try {
    const response = await api.get('/health')
    return response
  } catch (error) {
    if (error.status == 503) {
      console.log("Healthcheck failed: API service is not healthy.", error.response.data)
    } else if (error.status == 504) {
      console.log("Healthcheck failed: can't reach the API service.", error)
    } else {
      console.log("Healthcheck failed: unknown error", error)
    }

  }
}

async function runCheck() {
  let success = await tryHealth()
  let tries = 1

  while (!success && tries < 3) {
    await new Promise(resolve => setTimeout(resolve, 500));
    tries += 1
    success = await tryHealth()
  }
  return success
}

function continueAfterSucess(app, loader, form) {
  loader.remove()
  app.style.display = 'none'
  form.style.display = 'flex'
}

async function apiHealthCheck() {
  const app = document.getElementById('app-container')
  const loader = new Loader().createElement()
  const form = document.querySelector('form')
  app.appendChild(loader)

  const success = await runCheck()

  if (success) {
    continueAfterSucess(app, loader, form)
  } else {
    app.innerHTML = `${GlobeX} <br> server error`
    // '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe-x-icon lucide-globe-x"><path d="m16 3 5 5"/><path d="M2 12h20A10 10 0 1 1 12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 4-10"/><path d="m21 3-5 5"/></svg> <br>server error'
  }

}




apiHealthCheck()
